import { useEffect } from "react";
import { exposeDevHelpers } from "../devTools/serialIndexDev";

export function useDevTools(): void {
  useEffect(() => {
    exposeDevHelpers();
  }, []);
}
